<template>
  <dashboard-main-layout>
    <appbar-bordered v-if="installations.length > 0">
      <!-- Columns selector -->
      <template>
        <v-btn
          color="white dark--text text-none"
          dark
          elevation="0"
          @click.stop="showSelectionGroup = true"
          class="mx-5"
        >
          {{ $t("_colonnes_a_afficher_") }} ({{ selectedColumns.length }})
        </v-btn>
        <!-- <div>
					<v-alert
				type="info"
				elevation="2"
				border="left"
				color="red lighten-2"
				icon="mdi-information"
				class="mx-4 my-3"
				dense
				>
			<span class="white--text text--darken-3" style="font-size: 13px; font-weight: bold;">
				⚠️ Certaines fonctionnalités sont temporairement indisponibles (rapport, vues masques, calepinage, chaines déconnectées...). Notre équipe travaille activement à leur rétablissement. Veuillez nous excuser pour la gêne occasionnée.
				⚠️ Some features are temporarily unavailable (report, Mask view, layout, string disconnections...). Our team is working to resolve the issue. We apologize for the inconvenience.
			</span>
			</v-alert>
				</div> -->
        <v-dialog v-model="showSelectionGroup" max-width="490">
          <v-card>
            <div class="d-flex flex-wrap">
              <div v-for="(group, index) in groups" :key="index" class="col-6">
                <template>
                  <v-container
                    class="px-0"
                    fluid
                    @click="toggleGroupSelection(index, $event)"
                  >
                    <input
                      type="checkbox"
                      :checked="isGroupSelected(index) ? 'true' : ''"
                    />
                    <strong
                      class="ml-1"
                      :class="
                        isGroupSelected(index) ? 'blue--text' : 'dark--text'
                      "
                    >
                      {{ $t(group) }}
                    </strong>
                  </v-container>
                </template>
                <div
                  v-for="(column, index) in getColumns(index)"
                  :key="index"
                  class="ml-5"
                >
                  - {{ $t(column.text) }}
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>
      </template>
    </appbar-bordered>

    <!-- Tableau -->
    <div class="pa-4">
      <v-card
        v-if="installations !== undefined && installations.length > 0"
        elevation="0"
      >
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('_recherche_')"
            single-line
            hide-details
            :disabled="!installations || installations.length === 0"
          ></v-text-field>
        </v-card-title>
      </v-card>

      <v-data-table
        :headers="selectedColumnsOrdered"
        :items="filteredInstallations"
        :loading="loading"
        item-key="id"
        show-select
        :footer-props="{
          'items-per-page-options': [20, 50, 100, -1],
          'items-per-page-text': this.$t('_lignes_par_page_'),
        }"
        :items-per-page="20"
        id="level-1-table"
        :search="search || ''"
        v-if="installationsShowable"
      >
        <template v-slot:header.data-table-select="{ on, props }">
          <div
            class="d-flex justify-center"
            style="cursor: pointer"
            @click="toggleSelectAll()"
          >
            <!-- JTS : Bug on checkbox audit group-->
            <input type="checkbox" :checked="areSelected" />
            <!-- :disabled="areSelected"  -->
          </div>
        </template>

        <template v-slot:body="{ items }">
          <tbody>
            <tr
              v-for="(item, index) in items"
              :key="item.id"
              :class="{ disabled: item.is_forbidden }"
            >
              <td>
                <div
                  class="d-flex justify-center"
                  style="cursor: pointer"
                  @click="toggleInstallation(index)"
                >
                  <input
                    type="checkbox"
                    :checked="item && item.checked ? true : false"
                    @change="toggleInstallation(item)"
                  />
                </div>
              </td>

              <td
                v-for="column in selectedColumnsOrdered"
                :key="column.key"
                :style="
                  isFirstColumnOfGroup(column)
                    ? 'border-left:1px solid lightgray; cursor: pointer'
                    : 'cursor: pointer'
                "
                @click="goToInstallation(item, column.key)"
              >
                <installation-field
                  :column="column.key"
                  :item="item"
                  v-if="
                    column.key !== undefined &&
                    column.key !== 'actions' &&
                    column.key !== 'rapport'
                  "
                />

                <div v-else>
                  <div v-if="item.pdf_link.length > 0">
                    <a
                      href="#"
                      target="_blank"
                      @click.prevent="getPDF(item.pdf_link)"
                      style="cursor: pointer"
                    >
                      <v-icon> mdi-download-box </v-icon>
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </div>
  </dashboard-main-layout>
</template>

<script>
// Components
import DashboardMainLayout from "../../layouts/Dashboard/MainLayout";
import InstallationField from "../../components/Table/InstallationField";
import AppbarBordered from "../../components/Utils/AppbarBordered";
import { mapMutations } from "vuex";
import api from "../../api/api";
import { mapGetters } from "vuex";
import webconf from "../../utils/frontend_setup";

export default {
  components: {
    DashboardMainLayout,
    AppbarBordered,
    InstallationField,
  },

  data() {
    return {
      script_name: "Main.vue (Dashboard Niv1)", // For debug
      loading: false,
      target_menu: "",
      hoverInstallation: false,
      selectedColumns: [],
      showReportLink: false,
      showSelectionGroup: false,
      // showInstallationOtherColumnsMenu: false,
      search: "",
    };
  },

  watch: {
    $route: {
      handler() {
        this.$store.commit("SET_CUR_INSTALL_ID", null);
      },
      immediate: true,
      deep: true,
    },

    selectedGroups: {
      handler(val) {
        if (this.constants.columns)
          this.selectedColumns = this.constants.columns.filter((column) =>
            val.includes(column.group)
          );
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters(["cur_install_id"]),

    filteredInstallations() {
      if (!this.installations || !this.installations.length) return [];
      if (!this.search) return this.installations;

      const searchLower = this.search.toLowerCase();

      return this.installations.filter((item) => {
        return this.selectedColumnsOrdered.some((col) => {
          const val = item[col.key];
          return (
            val !== undefined &&
            val !== null &&
            val.toString().toLowerCase().includes(searchLower)
          );
        });
      });
    },
    constants() {
      webconf.debugLog(
        "computed",
        this.script_name,
        "constants",
        this.$store.getters.constants
      );
      return this.$store.getters.constants;
    },

    installationsShowable() {
      return (
        this.installations &&
        Array.isArray(this.installations) &&
        this.selectedColumnsOrdered &&
        this.selectedColumnsOrdered.length
      );
    },

    groups() {
      // Build group list
      const groupList = this.constants.columns
        .filter((group) => group.show_dashboard.includes(this.target_menu))
        .map((column) => column.group);

      const columns_group = this.constants ? this.constants.columns_group : [];

      let res = {};
      columns_group.forEach((column_group) => {
        if (groupList.includes(column_group.key)) {
          res[column_group.key] = column_group.title;
        }
      });
      return res;
    },

    selectedColumnsOrdered() {
      if (!this.selectedColumns || !this.selectedColumns.length) return [];
      const columns = this.$_.orderBy(this.selectedColumns, ["index"], ["asc"]);

      return columns.map((c) => ({
        key: c.key,
        group: c.group,
        index: c.index,
        text: c.text ? this.$t(c.text) : "",
        value: c.key,
      }));
      // return this.$_.orderBy(this.selectedColumns, ["index"], ["asc"]).map(
      //   (c) => {
      //     return {
      //       ...c,
      //       ...{
      //         text: this.$t(c.text),
      //         value: c.key,
      //       },
      //     };
      //   }
      // );
    },

    unselectedColumns() {
      return this.constants.columns.filter(
        (x) => !this.selectedColumns.includes(x)
      );
    },

    installations: {
      get() {
        return this.$store.getters.installations;
      },
      set(value) {
        this.$store.commit("SET_INSTALLATIONS", value);
      },
    },

    selectedGroups: {
      get() {
        return this.$store.state.parametersStore.installations_groups;
      },
      set(value) {
        this.$store.commit("SET_INSTALLATIONS_GROUPS", value);
      },
    },

    areSelected() {
      return !this.installations.filter((installation) => !installation.checked)
        .length;
    },

    dates() {
      webconf.debugLog(
        "computed",
        this.script_name,
        "constants",
        this.$store.state.parametersStore.dates
      );
      return this.$store.state.parametersStore.dates;
    },
  },

  methods: {
    async getPDF(repoId) {
      await api
        .getPDFUrl(repoId)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch(console.error);
    },

    toggleSelectAll() {
      if (this.areSelected) {
        this.installations = this.installations.map((installation) => {
          return { ...installation, ...{ checked: false } };
        });
        this.installations[0].checked = true;
      } else
        this.installations = this.installations.map((installation) => {
          return { ...installation, ...{ checked: true } };
        });
    },

    getColumns(group) {
      // Catch column group

      return this.constants.columns.filter(
        (column) =>
          column.group === group &&
          column.show_dashboard.includes(this.target_menu)
      );
    },

    isGroupSelected(group) {
      return this.selectedGroups.includes(group);
    },

    toggleInstallation(item) {
      //  Guard: ignore invalid items
      if (!item || typeof item !== "object") return;

      const updated = this.installations.map((inst) => {
        if (!inst || typeof inst !== "object") return inst;

        if (inst.id === item.id) {
          return { ...inst, checked: !inst.checked };
        }
        return inst;
      });

      this.$store.commit("SET_INSTALLATIONS", updated);
    },

    toggleGroupSelection(group, event) {
      if (this.isGroupSelected(group)) {
        if (this.selectedGroups.length > 1)
          this.selectedGroups = this.selectedGroups.filter((e) => e !== group);
        else event.preventDefault();
      } else this.selectedGroups.push(group);
    },

    isFirstColumnOfGroup(column) {
      if (column.key === "action_list") return true;
      const group = column.group;
      const columns = this.getColumns(group);
      return !columns.indexOf(column);
    },

    goToInstallation(installation, columnKey) {
      if (columnKey !== "rapport") {
        this.$store.dispatch("setInstallationAuditDate", {
          start_date: installation.audit_start_date,
          end_date: installation.audit_end_date,
        });

        this.$store.dispatch("setInstallationMaxDates", {
          start_date: installation.audit_start_date,
          end_date: installation.audit_end_date,
        });

        this.$store.dispatch("setShowDateSelector", { show: true });
        this.$store.commit("SET_EXPERT_PDM", this.current_pdm);

        this.$store.commit("SET_GEO_PDM", "");

        this.$store.commit("SET_CUR_INSTALL_ID", installation.id);
        const path = `/installations/show/${installation.id}`;
        if (this.$route.path !== path) this.$router.push(path);
      }
    },

    getInstallationList() {
      this.loading = true;

      return (
        this.$store
          // .dispatch("getInstallationList", {'analysis_mode': this.analysis_mode})
          .dispatch("getInstallationList")
          .then(async () => {
            this.loading = false;
            this.selectedColumns = this.constants.columns.filter((column) =>
              column.show_dashboard.includes(this.target_menu)
            );
          })
      );
    },

    ...mapMutations(["SET_INSTALLATIONS", "SET_SHOW_DATE_SELECTOR"]),
  },

  mounted() {
    this.target_menu =
      this.$route.name === "dashboard-audits" ? "audit" : "continuous";
    this.getInstallationList();
  },
};
</script>

<style>
.theme--light.v-data-table > .v-data-table__wrapper,
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr {
  border-radius: 5px;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr {
  background-color: rgb(214, 214, 214);
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #504f4f;
  padding-top: 10px;
  padding-bottom: 10px;
}

.theme--light.v-data-table .v-data-table-header th.sortable:hover,
.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon,
.theme--light.v-data-table .v-data-table-header th.sortable.active {
  color: #000000;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.theme--light.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.775rem;
  height: 55px;
}

.disabled {
  background-color: lightgray;
  pointer-events: none;
}
</style>
